import React from "react";

export interface TodoStats {
  pending: number;
  overdue: number;
  inProgress: number;
  onHold: number;
  completed: number;
}

interface TodoStatsBarProps {
  stats: TodoStats;
  /** Called with the status value ("0" | "overdue" | "1" | "2" | "3"). */
  onSelectStatus: (status: string) => void;
  /** Extra spacing class applied to each separated item (e.g. "me-3"). */
  gapClass?: string;
}

/**
 * The clickable Pending / Overdue / In-progress / On-hold / Completed counters.
 * Renders only the counters; the parent view supplies the surrounding layout.
 */
const TodoStatsBar: React.FC<TodoStatsBarProps> = ({
  stats,
  onSelectStatus,
  gapClass = "",
}) => {
  const sep = `mb-0 ${gapClass} pe-3 border-end fs-14`.trim();
  return (
    <>
      <p
        className={sep}
        style={{ cursor: "pointer" }}
        onClick={() => onSelectStatus("0")}
      >
        <span className="text-secondary">Pending:</span>{" "}
        <span className="text-secondary">{stats.pending}</span>
      </p>
      <p
        className={sep}
        style={{ cursor: "pointer" }}
        onClick={() => onSelectStatus("overdue")}
      >
        <span className="text-danger">Overdue:</span>{" "}
        <span className="text-danger">{stats.overdue}</span>
      </p>
      <p
        className={sep}
        style={{ cursor: "pointer" }}
        onClick={() => onSelectStatus("1")}
      >
        <span className="text-warning">In-progress:</span>{" "}
        <span className="text-warning">{stats.inProgress}</span>
      </p>
      <p
        className={sep}
        style={{ cursor: "pointer" }}
        onClick={() => onSelectStatus("2")}
      >
        <span className="text-danger">On-hold:</span>{" "}
        <span className="text-danger">{stats.onHold}</span>
      </p>
      <p
        className={`mb-0 ${gapClass} fs-14`.trim()}
        style={{ cursor: "pointer" }}
        onClick={() => onSelectStatus("3")}
      >
        <span className="text-success">Completed:</span>{" "}
        <span className="text-success">{stats.completed}</span>
      </p>
    </>
  );
};

export default TodoStatsBar;
